import { render, staticRenderFns } from "./FlagBadge.vue?vue&type=template&id=20d469a9&scoped=true"
import script from "./FlagBadge.vue?vue&type=script&lang=js"
export * from "./FlagBadge.vue?vue&type=script&lang=js"
import style0 from "./FlagBadge.vue?vue&type=style&index=0&id=20d469a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d469a9",
  null
  
)

export default component.exports